import IconDon from "@/assets/icons/don.svg?react";
import { formatNumber } from "@/shared/utils";
import { getImageByPriority } from "@/shared/utils/common";
import { ImageType } from "@/pages/challenges/types/common";

interface SenderBalanceCardProps {
  avatar: ImageType | null;
  username: string | null;
  walletAmount: number;
  isPremium?: boolean;
  className?: string;
}

export default function SenderBalanceCard({
  avatar,
  username,
  walletAmount,
  isPremium,
  className = "",
}: SenderBalanceCardProps) {
  return (
    <div className={`w-full rounded-xl bg-gray-4 border border-white/[0.04] p-3 flex items-center ${className}`}>
      <div
        className={`${
          isPremium ? "bg-yellow-linear" : "bg-white/08"
        } w-9 h-9 rounded-md p-px overflow-hidden mr-2.5 shrink-0`}
      >
        <img
          className="w-full h-full object-cover rounded-[5px]"
          src={
            avatar
              ? getImageByPriority(avatar, "small")
              : "images/default/user.svg"
          }
          alt="User Avatar"
        />
      </div>
      <div className="flex flex-col gap-0.5 min-w-0 flex-1">
        <div className="flex items-center gap-1">
          <IconDon className="size-5 text-orange-100" />
          <span className="text-lg font-semibold leading-130 text-orange-100 truncate">
            {formatNumber(walletAmount)}
          </span>
        </div>
        {username && (
          <p className="text-xs font-normal leading-130 text-gray-1 truncate">
            @{username}
          </p>
        )}
      </div>
    </div>
  );
}
